import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api/reset-queries'

import { GET_ALL_FOLDERS_BASE_QUERY_KEY } from './get-all-folders'
import { GET_FOLDER_CONTENT_BASE_QUERY_KEY } from './get-folder-content'

export interface DeleteCommunityEssentialRequest {
  id: number
  buildingId: number
}

export const deleteCommunityEssential = async (data: DeleteCommunityEssentialRequest) => {
  const response = await authAPI.delete(`/building-essential/${data.id}`)
  return response.data
}

export const useDeleteCommunityEssential = () => {
  return useMutation({
    mutationFn: deleteCommunityEssential,
    onSuccess: () =>
      resetQueries([GET_FOLDER_CONTENT_BASE_QUERY_KEY], [GET_ALL_FOLDERS_BASE_QUERY_KEY]),
  })
}
